module.exports = __webpack_public_path__ + "img/paytm.c8d2ca1f.png";